import { ApiRequest } from '../XHR/ApiRequest';
import { ApiUrls } from '../../Models/ApiUrls';
import { MeResponse } from '../../Models/Users/Me';

export class MeApi {
    public static getMyInfo = (): Promise<MeResponse> => {
        return ApiRequest.get<MeResponse>(ApiUrls.ME);
    };
}
